import { Stack, Card, Typography, Button } from '@mui/material';

import { Strings } from '@app/constants';
import { ICustomerAddress } from '../types';

interface Props {
  customer?: ICustomerAddress;
}

const labelSx = { fontSize: '14px' };

const toCoord = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
};

const CustomerDetailCard = ({ customer }: Props) => {
  const lat = toCoord(customer?.location?.latitude ?? customer?.location?.lat);
  const long = toCoord(customer?.location?.longitude ?? customer?.location?.long);
  const hasCoordinates = lat != null && long != null;

  const openInMaps = () => {
    if (!hasCoordinates) {
      return;
    }
    window.open(`https://www.google.com/maps?q=${lat},${long}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <Card sx={{ padding: '2% 2% 5% 2%', width: '50%', borderRadius: '5px' }}>
      <Typography variant="h6">{Strings.detailCard.customerDetails}</Typography>
      <Stack flexDirection="row" justifyContent="space-between">
        <Stack mt={5} gap={1.5}>
          <Typography sx={labelSx}>{Strings.detailCard.name}</Typography>
          <Typography sx={labelSx}>{Strings.detailCard.phone}</Typography>
          <Typography sx={labelSx}>{Strings.detailCard.addressType}</Typography>
          <Typography sx={labelSx}>{Strings.detailCard.address}</Typography>
          <Typography sx={labelSx}>{Strings.detailCard.city}</Typography>
          <Typography sx={labelSx}>{Strings.detailCard.state}</Typography>
          <Typography sx={labelSx}>{Strings.detailCard.pinCode}</Typography>
          <Typography sx={labelSx}>{Strings.detailCard.country}</Typography>
        </Stack>
        <Stack mt={5} ml={4} gap={1.5} flex={1}>
          <Typography sx={labelSx}>{customer?.name ?? 'NA'}</Typography>
          <Typography sx={labelSx}>
            {customer?.mobileNumber
              ? `${customer?.countryCode ?? ''}${customer?.mobileNumber}`
              : 'NA'}
          </Typography>
          <Typography sx={labelSx}>{customer?.addressType ?? 'NA'}</Typography>
          <Typography sx={labelSx}>{customer?.address ?? 'NA'}</Typography>
          <Typography sx={labelSx}>{customer?.city ?? 'NA'}</Typography>
          <Typography sx={labelSx}>{customer?.state ?? 'NA'}</Typography>
          <Typography sx={labelSx}>{customer?.pinCode ?? 'NA'}</Typography>
          <Typography sx={labelSx}>{customer?.country ?? 'NA'}</Typography>
        </Stack>
      </Stack>
      <Stack mt={3} alignItems="flex-start">
        <Button variant="outlined" size="small" disabled={!hasCoordinates} onClick={openInMaps}>
          {Strings.detailCard.openInMaps}
        </Button>
      </Stack>
    </Card>
  );
};
export { CustomerDetailCard };
